// extracted by mini-css-extract-plugin
export default {"cardGroupsContainer":"LaunchedSubCategories_cardGroupsContainer__+BQfP"};